import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import ErrorModal from "../../components/ErrorModal";
// import handleApiError from "../../../utils/handleApiError";
import SuccessModal from "../../components/SuccessModal";
import axios from "../../../axios";
import BannerForm from "./BannerForm";
import { STORAGE_URL } from "../../../constants";

export default function BannerEditPage() {
    const { id } = useParams();
    const [form, setForm] = useState({
        title: "",
        image: null,
    });

    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const [initialImage, setInitialImage] = useState("");

    useEffect(() => {
        axios.get(`/admin/banners`).then((res) => {
            const banner = res.data.find((b) => b.id === id);
            if (banner) {
                setForm({ title: banner.title, image: null });
                setInitialImage(`${STORAGE_URL}${banner.image}`);
            }
        }).catch(() => {
            setError("Gagal mengambil data banner.");
        });
    }, [id]);

    const handleSubmit = async (e) => {
        setLoading(true);
        
        e.preventDefault();
        setError("");

        const formData = new FormData();
        formData.append("title", form.title || "");
        if (form.image) {
            formData.append("image", form.image);
        }

        try {
            await axios.post(`/admin/banners/${id}?_method=PUT`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            setSuccess("Data berhasil ditambahkan!");
        } catch (err) {
            setError("Gagal menyimpan perubahan.");
        }
    };

    return (
        <>
            <Link to="/admin/banners" className="mt-3">Kembali</Link>
            <ErrorModal error={error} onClose={() => setError("")} />
            <SuccessModal
                message={success}
                onClose={() => {
                    setSuccess("");
                    navigate("/admin/banners");
                }}
            />
            <div className="card mt-4">
                <div className="card-header border-bottom">
                    <h4 className="mb-0">Edit Banner</h4>
                </div>
                <div className="card-body">
                    {error && <div className="alert alert-danger">{error}</div>}
                    {initialImage && (
                        <div className="mb-3">
                            <label>Gambar Saat Ini:</label><br />
                            <img src={initialImage} alt="Banner" style={{ maxWidth: 300 }} />
                        </div>
                    )}
                    <BannerForm form={form} setForm={setForm} onSubmit={handleSubmit} />

                </div>
            </div>
        </>
    );
}
